import { useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Paper,
  Grid,
  Chip,
  Tabs,
  Tab,
  Alert,
  TextField,
  Button,
} from "@mui/material";
import {
  Close as CloseIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Business as BusinessIcon,
  People as PeopleIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationIcon,
  TrendingUp as TrendingIcon,
  AccessTime as ClockIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { Formik, Form } from "formik";
import { DealForm } from "./Forms/DealForm";
import { getPriorityColor, getUserInfo } from "../utils/helpers";
import { Building2, CircleX, SquarePen, Trash2 } from "lucide-react";

// Helper functions
const getCompanyName = (deal) => {
  if (deal.companyName) return deal.companyName;
  if (deal.company && typeof deal.company === "string") return deal.company;
  if (deal.company && typeof deal.company === "object")
    return deal.company.name;
  return null;
};

const getContactName = (deal) => {
  if (deal.contactName) return deal.contactName;
  if (deal.contact) return `${deal.contact.firstName} ${deal.contact.lastName}`;
  return null;
};

export const DealDrawer = ({
  open,
  deal,
  stages,
  companies,
  contacts,
  notes,
  onClose,
  onUpdate,
  onDelete,
  check,
  onAddNote,
  onDeleteNote,
}) => {
  const [editMode, setEditMode] = useState(false);
  const { userName, userRole } = getUserInfo();

  if (!deal) return null;

  const stage = stages.find((s) => s._id === deal.stage);
  const contactName = getContactName(deal);
  const companyName = getCompanyName(deal);

  const handleUpdate = async (values, formikBag) => {
    const result = await onUpdate(values, formikBag);

    if (result?.success) {
      setEditMode(false);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {
        onClose();
        setEditMode(false);
      }}
      PaperProps={{ sx: { width: { xs: "100%", md: 500 } } }}
    >
      <Box>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            borderBottom: "1px solid #E5E7EB",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              textTransform: "capitalize",
            }}
          >
            {deal.dealName}
          </Typography>
          <Box>
            {(userRole === "admin" || userRole === "owner") && (
              <IconButton onClick={onDelete} sx={{ color: "#EF4444" }}>
                <Trash2 size={20} />
              </IconButton>
            )}
          </Box>
        </Box>

        {/* Content */}
        <Box sx={{ p: 3, maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}>
          <>
            <Alert severity="info" sx={{ mb: 3 }}>
              ✏️ Edit Mode - Update deal information
            </Alert>
            <DealForm
              initialValues={deal}
              onSubmit={handleUpdate}
              companies={companies}
              onClose={onClose}
              contacts={contacts}
              stages={stages}
              submitLabel="Save Changes"
              onCancel={() => setEditMode(false)}
            />
          </>
        </Box>
      </Box>
    </Drawer>
  );
};
